import type { ReportingFilters } from '../../../utils/types/reporting/reporting_types';
import { DEFAULT_REPORTING_TAB, REPORTING_TAB_IDS } from '../constants';
import type { ReportingTabId } from '../interfaces';

export const getDefaultDateRange = (): ReportingFilters['dateRange'] => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  return { startDate, endDate };
};

export const createDefaultFilters = (): ReportingFilters => ({
  dateRange: getDefaultDateRange(),
  departments: [],
  jobTitles: [],
  locations: [],
});

export const parseReportingTab = (tabParam?: string): ReportingTabId => {
  if (tabParam && REPORTING_TAB_IDS.includes(tabParam as ReportingTabId)) {
    return tabParam as ReportingTabId;
  }
  return DEFAULT_REPORTING_TAB;
};
 